/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { HttpErrorResponse } from '@angular/common/http';
import { ErrorResult } from '@app/app/shared/store';

/**
 * Converts an error from a HTTP request to a string.
 */
export function requestErrorToString(error: unknown): string {
  if (error instanceof HttpErrorResponse) {
    if (typeof error.error === 'object' && typeof error.error?.message === 'string') {
      return error.error.message as string;
    }

    if (typeof error.error === 'string') {
      return error.error as string;
    }

    return error.message;
  } else if (error instanceof ErrorResult) {
    return error.error;
  }

  return 'unknown error';
}
